import { CurrentCommunityContextProvider } from "@circle-react/contexts/currentCommunityContext";
import { SpaceGroupsContextProvider } from "@circle-react/contexts/spaceGroupsContext";

import { NewForm } from "./NewForm";
import type { NewFormProps } from "./NewForm";

import "./styles.scss";

export const NewV2 = (props: NewFormProps) => (
  <CurrentCommunityContextProvider>
    <SpaceGroupsContextProvider>
      <NewForm {...props} />
    </SpaceGroupsContextProvider>
  </CurrentCommunityContextProvider>
);
